<script setup>
import { ref, onMounted } from "vue";
import { Input, Icon, Dropdown, Editable, Spin, Button } from "@components";
import draggable from "vuedraggable";
import ServiceRow from "./ServiceRow.vue";

import { useService } from "@store/service";
const $service = useService();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const props = defineProps({
	categories: {
		type: Array,
		default: () => [],
	},
});

const state = ref({});

const openCategories = ref([]);
const toggleCategory = (category_id) => {
	// if include remove from array else add
	if (openCategories.value.includes(category_id)) {
		let index = openCategories.value.indexOf(category_id);
		openCategories.value.splice(index, 1);
	} else {
		openCategories.value.push(category_id);
	}
};

const isCategoryOpen = (category_id) => {
	return openCategories.value.includes(category_id);
};

const categoryOpenOnDragEnter = (category_id) => {
	state.value.dragEnterCategoryId = category_id;
	if (openCategories.value.includes(category_id)) return;
	openCategories.value.push(category_id);
};

onMounted(() => {
	props.categories.forEach((category) => {
		toggleCategory(category.category_id);
	});
});

const toggleOnClick = (category_id, event) => {
	if (
		event.target.tagName !== "DIV" ||
		event.target.classList.contains("prebook-icon") ||
		event.target.classList.contains("prebook-editable-input") ||
		event.target.classList.contains("prebook-editable")
	)
		return;

	toggleCategory(category_id);
};

const categoryChanged = async (event) => {
	console.log("category changed");
	props.categories.forEach((category, index) => {
		console.log({
			priority: category.meta.priority,
			index,
		});
		if (category.meta.priority !== index) {
			category.meta.priority =
				category.name == "Uncategorised" && props.categories.length == index + 1
					? 999
					: index; // if last category is Uncategorised then priority should be 999
			$service.updateCategory(category, false);
		}
	});
};

const serviceChanged = async (event) => {
	console.log("service changed");
	console.log({
		event,
		from_categories_id: event.from.attributes["data-category"].value,
		to_categories_id: event.to.attributes["data-category"].value,
		service_id: event.item.attributes["data-service"].value,
		newIndex: event.newIndex,
	});
	props.categories.forEach((category, index) => {
		category.services.forEach((service, index) => {
			console.log({
				service_name: service.name,
				service_category_id: service.category_id,
				category_id: category.category_id,
				serviceOrder: service.meta.order,
				index,
			});
			if (
				service.meta.order !== index ||
				service.category_id !== category.category_id
			) {
				service.meta.order = index;
				service.category_id = category.category_id;
				$service.updateService(service, false);
			}
		});
	});
};

// const changeViewport = (event) => {
//     console.log(event.clientY)
//     const scrollSpeed = 1
//     if (event.clientY >= window.innerHeight - 100) {
//         // Scroll down
//         // window.scrollTo(0, window.scrollY + 1)
//         window.scrollBy(0, scrollSpeed)
//     } else if (event.clientY <= 100) {
//         // Scroll up
//         // window.scrollTo(0, window.scrollY - 1)
//         window.scrollBy(0, -scrollSpeed)
//     }
// }

const prevY = ref(0);

const changeViewport = (event) => {
	const scrollSpeed = 2;
	const currentY = event.clientY;
	// auto scroll disable when not in top or bottom range
	// console.log(!(currentY >= window.innerHeight - 150 || currentY <= 150))
	if (!(currentY >= window.innerHeight - 100 || currentY <= 100)) return;
	// console.log(currentY)
	// console.log(currentY > prevY.value || currentY >= window.innerHeight - 100)
	if (currentY > prevY.value || currentY >= window.innerHeight - 80) {
		// Scroll down
		window.scrollBy(0, scrollSpeed);
	} else if (currentY < prevY.value || currentY <= 80) {
		// Scroll up
		window.scrollBy(0, -scrollSpeed);
	}

	prevY.value = currentY;
};
</script>

<template>
	<div>
		<draggable :list="props.categories" group="category" ghost-class="ghost" @end="categoryChanged($event)" item-key="category_id">
			<template #item="{ element, index }">
				<div class="mb-5" @dragenter="categoryOpenOnDragEnter(element.category_id)" @drag="changeViewport($event)" @dragend="prevY = 0">
					<!-- Category -->
					<div class="relative flex gap-4 mb-6">
						<div class="flex items-center cursor-move">
							<Icon name="menu05" class="text-[#98A2B3] w-5 h-6" />
						</div>
						<div @click="toggleOnClick(element.category_id, $event)" :class="{ 'cursor-pointer': access('service.add') }" class="h-[60px] w-full flex items-center justify-between p-4 relative border-r-[#D0D5DD] border-y-[#D0D5DD] border-t border-solid border-r border-b rounded-[0px_8px_8px_0px] border-l-[3px]" :style="`border-left-color: ${element.color}`">
							<div ref="title" class="text-[hsl(220,43%,11%)] text-xl font-semibold whitespace-nowrap flex items-center w-[calc(100%-180px)]">
								<Editable :submitButton="true" :border="false" :blur="state.saving" v-model="element.name" @submit="$service.updateCategory(element)" no-events :editable="element.name !== 'Uncategorised' && access('service.add') ? true : false"></Editable>
								<Spin v-if="state.saving"></Spin>
								<span class="text-[#667085] text-sm font-medium">#{{ element.category_id }}</span>
							</div>
							<div class="flex items-center justify-end w-full h-full gap-4">
								<div class="bg-[#98A2B3] px-3 py-1 rounded-[60px] !text-[#fff] text-sm font-bold">{{ element.services.length }}</div>

								<Dropdown v-if="element.category_id && element.name != 'Uncategorised' && access('service.add')" class="dropdown" contentClass="w-56 top-9 right-0 w-[117px]" no-events>
									<Icon name="dotsVertical" width="32px" height="26px" class="cursor-pointer text-[#98A2B3] transition-all hover:text-[#475467] hover:bg-[#EAECF0] rounded py-[1px] px-1" />
									<template #content>
										<div class="flex flex-col gap-0.5 px-1.5 py-1">
											<div class="transition rounded-md">
												<div @click="$service.deleteCategory(element.category_id)" class="px-2.5 py-[9px] flex gap-2 items-center transition-all hover:bg-[#F9FAFB] rounded-md cursor-pointer">
													<Icon size="16px" name="trash01" />
													<div class="text-[#344054] text-sm font-medium">Delete</div>
												</div>
											</div>
										</div>
									</template>
								</Dropdown>
								<Icon @click="toggleCategory(element.category_id)" name="chevronUp" size="24px" class="text-[#98A2B3] transition-all duration-300 cursor-pointer" :class="{ 'rotate-180': isCategoryOpen(element.category_id) }" />
							</div>
						</div>
					</div>

					<draggable v-if="isCategoryOpen(element.category_id)" :list="element.services" @end="serviceChanged($event)" :data-category="element.category_id" :emptyInsertThreshold="100" ghost-class="ghost" group="service" item-key="service_id" class="ml-[64px] rounded-[0px_8px_8px_0px] bg-white" style="width: calc(100% - 64px);">
						<template #item="{ element: service, index }">
							<ServiceRow :service="service" :index="index" :length="element.services.length" @drag="changeViewport($event)" @dragend="prevY = 0"></ServiceRow>
						</template>
					</draggable>

					<Button v-if="isCategoryOpen(element.category_id) && access('service.add')" :draggable="false" type="link_gray" classButton="ml-[64px] flex items-center gap-2 mb-3 mt-5" @click.prevent="$router.push({ name: 'service.add', query: { categoryId: element.category_id } })">
						<Icon name="plusCircle" class="w-4" />
						Add {{ String($settings.labels.service?.singular).toLowerCase() }}
					</Button>
				</div>
			</template>
		</draggable>
	</div>
</template>

<style>
/* Add your styles here */
.ghost {
	opacity: 0.5;
	background: #f2f4f7;
	/* background: #F9FAFB; */
}
</style>